import {computed, observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class TempoMedioRespostaPoolStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.indicadorService = new IndicadorService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findTempoMedioRespostaPool(filtro).then(response => {
            const fornecedoresDistinct = _.uniqBy(response.data, 'fornecedor');

            this.dados = _.map(fornecedoresDistinct, (fornecedor) => ({
                nome: fornecedor.fornecedor,
                "Com indicação": this.getQuantidadePorFornecedorEIndicacao(response.data, fornecedor.fornecedor, 1),
                "Sem indicação": this.getQuantidadePorFornecedorEIndicacao(response.data, fornecedor.fornecedor, 0)
            }));

            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    getQuantidadePorFornecedorEIndicacao = (fornecedores, nome, indicacao) => {
        const fornecedor = _.find(fornecedores, {
            "fornecedor": nome,
            "indicacao": indicacao
        });

        return fornecedor ? fornecedor.tempoMedio : 0;
    }
}
